import { Page } from '../components';
import { GeoMileageForm } from '../forms';

export const GeoMileage = () => <Page render={() => <GeoMileageForm />} />;
